// Motion helpers (DESIGN_SPEC §13): reduced-motion checks and same-document View Transitions.
//   scrollBehavior()         "smooth" unless reduced motion is requested (scrollIntoView / scrollTo)
//   viewTransition(update)   wrap a React state update in document.startViewTransition (tabs, rails)
//   quietSkippedTransitions()   once at startup: a transition cut short by a newer one (fast route or
//                               tab changes) rejects `ready` with an AbortError nobody awaits; that is
//                               expected, so it stays out of the console
import { flushSync } from "react-dom";

const QUERY = "(prefers-reduced-motion: reduce)";

function media(): MediaQueryList | null {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(QUERY) : null;
}

function prefersReducedMotion(): boolean {
  return media()?.matches ?? false;
}


export function scrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? "auto" : "smooth";
}

/** Falls back to a plain update where View Transitions are unsupported or motion is reduced. */
export function viewTransition(update: () => void): void {
  if (typeof document === "undefined" || typeof document.startViewTransition !== "function" || prefersReducedMotion()) {
    update();
    return;
  }
  document.startViewTransition(() => {
    flushSync(update); // the DOM must be updated synchronously inside the callback
  });
}

let quieted = false;

export function quietSkippedTransitions(): void {
  if (quieted || typeof window === "undefined") return;
  quieted = true;
  window.addEventListener("unhandledrejection", (e) => {
    const r: unknown = e.reason;
    if (r instanceof DOMException && r.name === "AbortError" && /transition/i.test(r.message)) e.preventDefault();
  });
}
